import React, { useState,useEffect, useContext } from 'react';
import './payment.css'
import Sidebar from '../../components/Sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Link,useParams } from 'react-router-dom'
import { faAddressCard, faAngleRight, faBook, faCircleCheck, faCircleInfo, faClose, faEnvelopeCircleCheck, faFileCirclePlus, faFileLines, faPlus, faSignature, faStamp, faUserLock, faUserPen } from '@fortawesome/free-solid-svg-icons'
import BackLoader from '../../components/backloader';


import * as Constants from '../../constants';
import TopBar from '../../components/topbar';
import { ShareContext } from '../../context/ShareContext'

function Profile() {
    const { profile } = useContext(ShareContext)
    const navigate = useNavigate();
    
  //  const profileid=Constants.isServerEnv? Constants.getCookie("profilename"):'seniola1' ;  
    const url=`${Constants.apiUrl}/gazette/eswearing/${profile.username}`;

    const urlcfo=`${Constants.apiUrl}/gazette/cfodocuments/pending`;

    const tempUrl= `${Constants.apiUrl}/gazette/templates/document`;

    const urlSaveInst = `${Constants.apiUrl}/gazette/uploadinstrument/${profile.username}`;
    const urlInstrument=`${Constants.apiUrl}/gazette/instrument/${profile.username}`;

    const [docs, setDocs] = useState([]);
    const [cases, setCases]=useState([]);
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [templates, setTemplates]=useState([]);
    const [isSchedule, setIsSchedule] =useState(false);
    const [schedule, setSchedule]= useState({});
    const [alert, setAlert] = useState({open:false})
    const [isCfo, setIsCfo] = useState(false);
    //for quick upload //load instrument too

    const [seal, setSeal]=useState('');
    const [passport, setPassport] =useState('');
    const [sign, setSign] =useState('');
    const [stamp, setStamp] =useState('');
const [signature, setSignature] =useState('');
const [initial, setinitial] =useState('');
    const [imgPrev, setImgPrev]=useState ({data:'', type:'', open:false});
   
    const onSelectSchedule=(item)=>{
        console.log(item);
        setIsSchedule(true);
        setSchedule({...schedule, doc:item});

        
    }
    const onSaveSchedule=()=>{
        console.log(schedule);
        var sch={docid:schedule.doc.id, zoomLink:schedule.zoom, scheduledBy:profile.username, scheduleDate : (schedule.date+' '+schedule.time)};

        setIsSchedule(false);
        const uploadurl=`${Constants.apiUrl}/gazette/schedule/${schedule.doc.id}`
        const formData = new FormData();
          

            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(sch),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                if(data.code==0){
                    //saved already
                    //first upldate the row and show dialog box
                    setDocs(docs.map(i => i.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, scheduleDate:sch.scheduleDate} : i));

                   setSchedule({});
                   setAlert({open:false, title:'Schedule an Appointment', subtitle:'Schedule successfully'})
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    }

    const onLoadInstrument= async()=>{
        //for account registration
        console.log(`the calling url ${urlInstrument}`);
        try {
            setIsLoading(true);
            const resp = await fetch(urlInstrument, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
                console.log('the loaded instrument');
                console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
const onSetImg =(path,type)=>{
        const ct=type.toLowerCase()
        if(ct=='seal'){
            setSeal(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='passport'){
            setPassport(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='signature'){
            setSignature(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='stamp'){
            setStamp(  `${Constants.docUrl}instrument/${path}`);
        }
      else if(ct=='initial'){
        setinitial(  `${Constants.docUrl}instrument/${path}`);
        }
    }
 

    // LEGAL COUNSEL STATES
    const [openLegalDoc, setOpenLegalDoc] = useState(false)
    const [typeTemp, setTypeTemp] = useState('')
    const [isUploadClick, setIsUploadClick] = useState(false)
    const [uploadType, setUploadType] = useState('')
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedFile, setActiveFile] = useState();

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setActiveFile(file);
        if (file) {
          const reader = new FileReader();
    
          reader.onload = () => {
            setSelectedImage(reader.result);
          };
    
          reader.readAsDataURL(file);
        }
      }

    const openTemp = (type) => {
        setOpenLegalDoc(true)

        if (type === 'affidavit') {
            setTypeTemp('affidavit')
        } else if (type === 'case-doc') {
            setTypeTemp('case-doc')
        }
    }

    const openUpload = (item) => {
        setIsUploadClick(true)

        if (item === 'sign') {
            setUploadType('Signature')
        } 
        else if (item === 'seal') {
            setUploadType('Seal')
        } else if (item === 'stamp') {
            setUploadType('Stamp')
        } else if (item === 'passport') {
            setUploadType('Passport')
        } else if (item === 'initial') {
            setUploadType('Initial')
        } else if (item === 'signature') {
            setUploadType('signature')
        }
    }

    const cancelUpload = () => {
        setIsUploadClick(false)

        setSelectedImage(null)
    }

    useEffect(() => {
        onLoad();
        LoadTemplates();
        onLoadInstrument();
      }, []);

      useEffect(() => {
       if((profile.role=='CommissionerForOaths' || profile.role=='e-CFO' || profile.role=='e-Commissioner for Oaths' || profile.role=='ACR' || profile.role=='e-ACR')  ){
        onLoadCfoData();
        setIsCfo(true);
       }
      }, [profile]);


      const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs)
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onLoadCfoData= async()=>{
        //for account registration
        console.log(`the calling url ${urlcfo}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    const LoadTemplates=()=>{
        // setIsLoading(true);
         fetch(tempUrl, {
             method: 'GET',
             headers: {
               'Content-type': 'application/json',
             },
           })
             .then((resp) => resp.json())
             .then((data) => {
               //  setIsLoading(false);
                 if(data.code==0){
                     setTemplates(data.templates);
                 }
                 
             })
             .catch(error => {
                 console.error(error);
                 //setIsLoading(false);
             })
     }

    const getTitle=(caseid)=>{
        var cc= cases.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else
         return cc[0].caseTitle;
     }
     const getCaseNum=(caseid)=>{
        var cc= cases.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else{
            var cnum=cc[0].caseNumber;
            var inf= cnum.indexOf('Temp');

           return inf==-1? cc[0].caseNumber:getCaseRef(caseid); 
         }
         
     } 
     
     const getCaseRef=(caseid)=>{
        
        var cc= refs?.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else
         return cc[0]?.referenceNumber;
     }

      const onView=(item)=>{
        var a={...item,caseTitle: getTitle(item.caseId),caseNumber:getCaseNum(item.caseId), type:'user'   };
        navigate("/view-document", {state: {item:a}});
 }

    const onSaveInst=()=>{
        onUploadIns();
    }
    const onUploadIns= async()=>{
        console.log('imgPrev data');
        console.log(selectedImage);
     
      
            setIsLoading(true);    
        //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
            var ext=selectedFile.name.split('.')[1];
            var b64=await Constants.toBase64(selectedFile);
            var rdata={base64: b64.split(',')[1],instType:uploadType,ext,changereason:'Initial'};
            // Sending the FormData using fetch
            fetch(urlSaveInst, {
            method: 'POST',
            body: JSON.stringify(rdata),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   
                   setAlert( {...alert, title:imgPrev.type, open:true, subtitle:`Saved ${imgPrev.type} successfully`, onOk })
                   setIsUploadClick(false)
                   onSetImg(data.instPath,uploadType);
                   setSelectedImage(null)
                   setActiveFile(null);
                   setUploadType('')
                   
                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const onOk=()=>{
        setAlert({open:false});
    }
    // CFO STATES
    const [whichTable, setWhichTable] = useState('submitted')

    const dummyCfoTable = [
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        }
    ]

    const approvedDocs = dummyCfoTable.filter(item => item.status === 'Approved');

    const submiitedDocs = dummyCfoTable.filter(item => item.status === 'Submitted');

    const changeTable = (type) => {
        if (type === 'submitted') {
            setWhichTable('submitted')
        } else if (type === 'approved') {
            setWhichTable('approved')
        }
    }


  return (
    <div className='payment-records'>
        <Sidebar />
        <div className="body">
           <TopBar title="Home/Profile" />
            <div className="container">
               

               <div>
               <div className="dashboard-view">
                        <h2>Instruments</h2>
                        <div className="action-btns" style={{flexWrap:'wrap'}}>
                            <div className="upload-dash" onClick={() => openUpload('initial')}>
                                {initial==''?<div className="icon-text" >
                                    <FontAwesomeIcon icon={faSignature} />
                                    <p>Upload Initial</p>
                                </div>:<img src={ initial} alt="Initial"  style={{width:100, height:100}}/>}
                                {initial!='' && <div className="icon-text" > <p> Initial</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>
                            <div className="upload-dash" onClick={() => openUpload('seal')}>
                              {seal==''?<div className="icon-text">
                                    <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
                                    <p>Upload Seal</p>
                                </div>:<img src={ seal} alt="Seal" style={{width:100, height:100}} />}
                                {seal!='' && <div className="icon-text" > <p>{isCfo && 'CFO'} Seal</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('stamp')}>
                                {stamp==''? <div className="icon-text"> 
                                    <FontAwesomeIcon icon={faStamp} />
                                    <p>Upload Stamp</p>
                                </div>:<img src={stamp} alt="Stamp"  style={{width:100, height:100}}/>}
                                {stamp!='' && <div className="icon-text" > <p> {isCfo && 'CFO'} Stamp</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it'/>
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('passport')}>
                                {passport==''?<div className="icon-text">
                                
                                    <FontAwesomeIcon icon={faAddressCard} />
                                    <p>Upload Passport</p>
                                </div>:<img src={passport} alt="Passport"  style={{width:100, height:100}} />}
                                {passport!='' && <div className="icon-text" > <p> Passport</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it' />
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('signature')}>
                                {signature==''?<div className="icon-text">
                                
                                    <FontAwesomeIcon icon={faAddressCard} />
                                    <p>Upload signature</p>
                                </div>:<img src={signature} alt="signature"  style={{width:100, height:100}} />}
                                {passport!='' && <div className="icon-text" > <p> Signature</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it' />
                            </div>
                        </div>
                    </div>
               </div>

            </div>
            <div className={ isUploadClick ? "template-pop open" : "template-pop"}>
            <div className="upload-wrap">
                <h3>Upload {uploadType}</h3>
                <div className="upload-file-btn">
                    <label htmlFor="upload-input">{ selectedImage ? 'Change Image' : 'Upload Image'}</label>
                    <input
                        type="file"
                        id="upload-input"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                     {selectedImage && (
                        <img src={selectedImage} alt="Uploaded Document"  style={{width:150}}/>
                        )}
                </div>  

                <p className="warn">Maximum File Upload: 2MB</p>

             

                <button className='red' onClick={() => cancelUpload()}>Cancel</button>
                <button className="black" onClick={onSaveInst}>Upload</button>
            </div>
        </div>
            <div className="goBack" onClick={() =>  navigate('/categories')}>
                <FontAwesomeIcon icon={faArrowLeft} />
                <p>Back to Home</p>
            </div>
            <BackLoader open={isLoading}  />
        </div>
    </div>
  )
}

export default Profile